import { render, staticRenderFns } from "./userOnlineCount.vue?vue&type=template&id=24942152&"
import script from "./userOnlineCount.vue?vue&type=script&lang=js&"
export * from "./userOnlineCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24942152')) {
      api.createRecord('24942152', component.options)
    } else {
      api.reload('24942152', component.options)
    }
    module.hot.accept("./userOnlineCount.vue?vue&type=template&id=24942152&", function () {
      api.rerender('24942152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/userOnlineCount.vue"
export default component.exports